import { render, staticRenderFns } from "./CoinSetting.vue?vue&type=template&id=2a0d59c4&"
import script from "./CoinSetting.vue?vue&type=script&lang=js&"
export * from "./CoinSetting.vue?vue&type=script&lang=js&"
import style0 from "./CoinSetting.vue?vue&type=style&index=0&id=2a0d59c4&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports